module.exports = __webpack_public_path__ + "static/media/sketch-inverted-cvo-road-glide.cc29179c.png";